import { FunctionComponent } from "react";
import { Navbar } from "@App/Components/Navbar";
import { Footer } from "@App/Layouts/Footer";
import { Outlet } from "react-router-dom";
import { State } from "@App/state";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export const Layout: FunctionComponent = () => {
  const service = useSelector((state: State) => state.orders.service);
  const organization = useSelector((state: State) => state.orders.organization);
  const { t } = useTranslation();

  const backlink = () => {
    if (
      service &&
      !!organization.settings.hero.service_links.find((link) => link.id == service.id)
    ) {
      return organization.settings.hero.service_links.find((link) => link.id == service.id).url;
    }
    return organization.settings.hero.link;
  };
  return (
    <div className="font-sans text-neutral-900">
      <Navbar>
        <div className={"flex items-center gap-5"}>
          <img src="/images/brand/ayvens.png" className="w-48 h-auto -ml-6" alt="Ayvens" />
          <a
            href={backlink()}
            className=" hidden md:flex gap-1 items-center text-xs text-neutral-700 font-normal no-underline border border-neutral-300 rounded p-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-4 w-4"
              viewBox="0 0 20 20"
              fill="#2f3237"
            >
              <path
                fillRule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
            {t("layout.backText")}
          </a>
        </div>
        <a href={"https://www.repareo.de"} className={"flex"} title={"repareo Werkstattvergleich"}>
          <img
            src="/images/brand/logoBlack.svg"
            className="w-28 h-auto"
            alt="repareo - Werkstattvergleich"
          />
        </a>
      </Navbar>
      <Outlet />
      <Footer />
    </div>
  );
};
